import { AccessManagementAction } from "features/panelManagement/accessManagement/types/actions";
import { getToken } from "features/auth/functions/token";
import { ENDPOINT } from "services/axios/constants/endpoints";
import { HTTPMethods } from "services/axios/types/http";
import { getDataFromRequest } from "services/axios/utility/helper";
import { AppThunk } from "services/redux/rootReducer";

const listAllUsers = (): AppThunk => async (dispatch) => {
    const users =
        (
            await getDataFromRequest(
                ENDPOINT.FUNCTIONS_API.USERS,
                HTTPMethods.GET,
                getToken()
            )
        )?.users || [];

    dispatch({
        type: AccessManagementAction.SET_USERS,
        users,
    });
};

export default listAllUsers;
